
(function() {
  var result = { translations: {} };
  hns('I18n', result);
})();


